import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useScrollToTop } from '../../../helpers/hooks/useScrollToTop';
import usePageTitle from '../../../services/hooks/usePageTitle';
import MeterkastScheduledContent from '../components/MeterkastScheduledContent/MeterkastScheduledContent';
import styles from './MeterkastScheduled.module.scss';

const MeterkastScheduled: FC = () => {
  const { t } = useTranslation();

  usePageTitle(t('pageTitle:meterkastScheduled'));
  useScrollToTop();

  return (
    <div className={styles.page}>
      <MeterkastScheduledContent />
    </div>
  );
};

export default MeterkastScheduled;
